import { render, staticRenderFns } from "./DialogSubmitMusic.vue?vue&type=template&id=7754a80a&scoped=true&"
import script from "./DialogSubmitMusic.vue?vue&type=script&lang=js&"
export * from "./DialogSubmitMusic.vue?vue&type=script&lang=js&"
import style0 from "./DialogSubmitMusic.vue?vue&type=style&index=0&id=7754a80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7754a80a",
  null
  
)

export default component.exports